export const LOCAL_STORAGE_KEYS = {
    SELECTED_VARIATIONS: "foodpilot_selected_variations",
    USER_PREFERENCES: "foodpilot_user_preferences",
    LAST_SELECTED_COMPANY: "foodpilot_last_company",
    LAST_SELECTED_CAMPAIGN: "foodpilot_last_campaign",
};

export const CHART_DEFAULTS = {
    MAX_PRECISION: 5,
    DEFAULT_PRECISION: 2,
};

export const SCORE_TYPES = {
    ENVIRONMENTAL: "environmental",
    SOCIAL: "social",
    ECONOMIC: "economic",
};

// Tag management constants
export const TAG_CACHE_TIME = {
    TAG_DATA: 5 * 60 * 1000, // 5 minutes for tag types/values
    STATS: 10 * 60 * 1000, // 10 minutes for statistics
    OVERVIEW: 5 * 60 * 1000, // 5 minutes for overview data
} as const;

export const TAG_PAGINATION = {
    DEFAULT_PAGE_SIZE: 20,
    TAG_OVERVIEW_ITEMS: 100,
    MAX_STATS_ITEMS: 1000, // For legacy stats endpoint (to be removed)
    ENTITY_TAG_LIST_SIZE: 25,
} as const;

export const TAG_UI_CONFIG = {
    MAX_VISIBLE_TAGS: 3, // CompactTagDisplay
    DEBOUNCE_DELAY: 300, // Search debounce in ms
    SKELETON_ITEMS: 2, // Number of skeleton items to show
} as const;

export const TAG_VALIDATION = {
    MAX_TAG_NAME_LENGTH: 100,
    MAX_DESCRIPTION_LENGTH: 500,
    MIN_SORT_ORDER: 0,
    MAX_SORT_ORDER: 9999,
} as const;

export const TEMP_ID_PREFIX = "temp-" as const;

export const SSQ_FIELD_TYPES = {
    GROUP: "group",
    NUMBER: "number",
    TEXT: "text",
    LONG_TEXT: "long_text",
    SELECT: "select",
    RADIO: "radio",
    CHECKBOX: "checkbox",
    DATE: "date",
    DATERANGE: "daterange",
} as const;

export const LONG_TEXT_MAX_LENGTH = 2000;

export const JSON_ATTRIBUTE_ENTITY_CLASS = {
    product: "App\\Core\\Catalog\\Product\\Entity\\Product",
    ingredient: "App\\Core\\Catalog\\Ingredient\\Entity\\Ingredient",
    organization: "App\\Core\\Tenancy\\Entity\\Organization",
    user: "App\\Core\\Identity\\User\\Entity\\User",
} as const;

export const ENTITY_CLASS_LABELS: Record<string, string> = {
    "App\\Entity\\Product": "Produit",
    "App\\Entity\\Ingredient": "Ingrédient",
    "App\\Entity\\Company": "Entreprise",
    "App\\Cms\\Entity\\Content\\Content": "Contenu CMS",
    "App\\Entity\\User": "Utilisateur",
} as const;

export const ENTITY_CLASS_TO_CONTEXT: Record<string, string> = {
    "App\\Entity\\Product": "product",
    "App\\Entity\\Ingredient": "ingredient",
    "App\\Entity\\Company": "company",
    "App\\Cms\\Entity\\Content\\Content": "cms",
    "App\\Entity\\User": "global",
} as const;
